// extracted by mini-css-extract-plugin
export var phone = "_3k-0";